import { amGeometryMultiPolygonSchema, amGeometryPolygonSchema } from 'src/common-services/types/alphamap/geojson-types'
import z from 'zod'

export const amCensusBlockShema = z.object({
  id: z.string(),
  geometry: amGeometryPolygonSchema,
})

export type AMCensusBlock = z.infer<typeof amCensusBlockShema>

export const amCensusBlockByIdRequestShema = z.object({
  id: z.string(),
})

export type AMCensusBlockByIdRequest = z.infer<typeof amCensusBlockByIdRequestShema>

export const amCensusBlocksRequestShema = z.object({
  ids: z.string().array(),
})

export type AMCensusBlocksRequest = z.infer<typeof amCensusBlocksRequestShema>

export const amCensusBlockGroupShema = z.object({
  id: z.string(),
  geometry: amGeometryMultiPolygonSchema,
})

export type AMCensusBlockGroup = z.infer<typeof amCensusBlockGroupShema>

export const amCensusBlockGroupByIdRequestShema = z.object({
  id: z.string(),
})

export type AMCensusBlockGroupByIdRequest = z.infer<typeof amCensusBlockGroupByIdRequestShema>

export const amCensusBlockGroupsRequestShema = z.object({
  ids: z.string().array(),
})

export type AMCensusBlockGroupsRequest = z.infer<typeof amCensusBlockGroupsRequestShema>

export const amZipCodeSchema = z.object({
  id: z.string(),
  geometry: amGeometryMultiPolygonSchema,
})

export type AMZipCode = z.infer<typeof amZipCodeSchema>

export const amZipCodesRequestSchema = z.object({
  ids: z.string().array(),
})

export type AMZipCodesRequest = z.infer<typeof amZipCodesRequestSchema>

const amH3ShapeSchema = z.object({
  id: z.string(),
  geometry: amGeometryPolygonSchema,
})
export type AMH3Shape = z.infer<typeof amH3ShapeSchema>
